import { gql } from '@apollo/client'
import employeeCoreFragment from './employeeCore.fragment'

export default gql`
  fragment EmployeeDisplay on Employee {
    id
    ...EmployeeCore
    avatarUrl
    currentEmployeeLevel
  }
  ${employeeCoreFragment}
`
